import { Suspense, lazy } from "react";
import type { RouteObject } from "react-router";

import type { DashboardArtifactsDetailsQuery } from "@app_schema";

import type { Breadcrumb } from "@application/types/breadcrumb";

import { DASHBOARD_ARTIFACTS_DETAILS_LOADER } from "@application/loaders/dashboard_artifacts_details_loader";
import { DASHBOARD_ARTIFACTS_LIST_LOADER } from "@application/loaders/dashboard_artifacts_list_loader";

import { DASHBOARD_ARTIFACTS_LINK } from "@application/navigation/dashbaord_artifacts_link";

import { Loader } from "@styled/loader";

const DashboardArtifactsDetails = lazy(() =>
  import("./artifacts_details").then((m) => ({
    default: m.DashboardArtifactsDetails,
  })),
);
const DashboardArtifactsEdit = lazy(() =>
  import("./artifacts_edit").then((m) => ({
    default: m.DashboardArtifactsEdit,
  })),
);
const DashboardArtifactsList = lazy(() =>
  import("./artifacts_list").then((m) => ({
    default: m.DashboardArtifactsList,
  })),
);
const DashboardAtifactsNew = lazy(() =>
  import("./artifacts_new").then((m) => ({ default: m.DashboardAtifactsNew })),
);

export const DASHBOARD_ARTIFACTS_ROUTE = {
  path: "artifacts",
  handle: DASHBOARD_ARTIFACTS_LINK,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardArtifactsList />
        </Suspense>
      ),
      loader: DASHBOARD_ARTIFACTS_LIST_LOADER,
    },
    {
      path: ":id",
      loader: DASHBOARD_ARTIFACTS_DETAILS_LOADER,
      handle: (data: DashboardArtifactsDetailsQuery): Breadcrumb => ({
        name: `${data.artifact.name}`,
        to: `/dashboard/artifacts/${data.artifact.id}`,
      }),
      children: [
        {
          index: true,
          loader: DASHBOARD_ARTIFACTS_DETAILS_LOADER,
          element: (
            <Suspense fallback={<Loader />}>
              <DashboardArtifactsDetails />
            </Suspense>
          ),
        },
        {
          path: "edit",
          element: (
            <Suspense fallback={<Loader />}>
              <DashboardArtifactsEdit />
            </Suspense>
          ),
          loader: DASHBOARD_ARTIFACTS_DETAILS_LOADER,
          handle: (data: DashboardArtifactsDetailsQuery): Breadcrumb => ({
            name: "Edit",
            to: `/dashboard/artifacts/${data.artifact.id}/edit`,
          }),
        },
      ],
    },

    {
      path: "new",
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardAtifactsNew />
        </Suspense>
      ),
      handle: {
        name: "New",
        to: "/dashboard/projects/new",
      },
    },
  ],
} satisfies RouteObject;
